import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { MoneyTextBoxEditor } from "../../../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Money } from "../../../../../../../Wrap/Core/DataTypes/Money";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { Table } from "../../../../../../Shared/Table/Table";
import { SectionHeader } from "../../../Common/SharedComponents";

interface IChooseAssetsOneOffProps extends IProcessComponentProps {
    totalValue: Money;
    onChange: (newAllocation: Money, productId: number) => void;
    data: UserAssetsAllocationData[];
}

interface IChooseAssetsOneOffState {
    totalAssetValue: number;
}

export class UserAssetsAllocationData{
    AssetId: number;
    Investment: string;
    AvailableMarketValue: Money;
    Allocation: Money;
}

export class UserAssetsAllocationTable extends ProcessComponent<IChooseAssetsOneOffProps, IChooseAssetsOneOffState> {
    constructor(props: any) {
        super(props);
        this.state = { totalAssetValue: this.getTotalAssetValue(props.data) };
    }

    componentDidMount() {
        super.componentDidMount();
        this.setState({ totalAssetValue: this.getTotalAssetValue(this.props.data) });
    }

    public componentWillReceiveProps(nextProps: IChooseAssetsOneOffProps) {
        if (nextProps.data !== this.props.data) {
            this.setState({ totalAssetValue: this.getTotalAssetValue(nextProps.data) });
        }
    }

    public isValid(): boolean {
        const flag = super.isValid();
        if (this.state.totalAssetValue !== this.props.totalValue.Amount) {
            this.props.showErrorMsgPopUp(["Allocation in user assets table doesn't match total payment amount"]);
        }
        return flag && this.state.totalAssetValue == this.props.totalValue.Amount;
    }

    private getTotalAssetValue(data: UserAssetsAllocationData[]): number {
        return data.reduce((total, ele) => {
            const allocationValue = ele.Allocation?.Amount ?? 0
            return total + allocationValue;
        }, 0);
    }

    private onAssetAllocationChange(newValue: number, assetId: number): void{
        const newAllocation: Money = { Amount: newValue, Currency: this.props.totalValue.Currency }
 
        this.props.onChange(newAllocation, assetId);
    }

    public render(): JSX.Element {
        return (
            <>
                {SectionHeader("Users assets")}
                <Table
                    data={this.props.data}
                    col={[
                        {
                            title: "Investment",
                            key: "Investment",
                            render: (data) => {
                                return <a className="hyper-link">{data}</a>;
                            },
                        },
                        {
                            title: "Available market value",
                            key: "AvailableMarketValue",
                            render: (data: Money) => {
                                return MoneyDisplayHelper.getMoneyFormat(data)
                            }
                        },
                        {
                            title: "Allocation",
                            key: "Allocation",
                            render: (data, row) => {
                                return (
                                    <MoneyTextBoxEditor
                                        disabled={false}
                                        value={data?.Amount}
                                        maxNumberOfDecimalPlaces={{
                                            errorMessage: "Only two decimal places allowed",
                                            value: 2,
                                        }}
                                        atMost={{
                                            value: row.AvailableMarketValue.Amount,
                                            errorMessage: "Value can not be larger than available market value",
                                        }}
                                        cssWrapper="mt-5 mb-0"
                                        infoTextGridClasses="mb-0"
                                        currency={data?.Currency ?? CurrencyCode.GBP}
                                        onChange={(v) => {
                                            this.onAssetAllocationChange(v, row.AssetId);
                                        }}
                                    />
                                );
                            },
                        },
                    ]}
                    TotalBody={[
                        { data: "Total", colSpan: 2 },
                        {
                            data: (
                                <span
                                    className={
                                        this.state.totalAssetValue == this.props.totalValue.Amount
                                            ? "text-positive"
                                            : "text-text"
                                    }
                                >{`${this.state?.totalAssetValue?.toFixed(2)}`}</span>
                            ),
                        },
                    ]}
                />
            </>
        );
    }
}
